/**
 * 微信关注者  
 */
import React from 'react';
import { Input, Row, Col, Icon, Tooltip } from 'antd';
import PageLayout from '../../ui/PageLayout';
import messager from '../../ui/messager';
import http from '../../../axios/http';
import { global_data } from '../../ui/auth'

class WechatUserIndex extends React.Component {

    columns = [{
        title: '用户名',
        dataIndex: 'username',
        width: '10%',
    }, {
        title: "微信昵称",
        dataIndex: 'nickname',
        width: '7%',
    }, {
        title: 'openid',
        dataIndex: 'openid',
        width: '10%',
    }, {
        title: '性别',
        dataIndex: 'sex',
        width: '5%',
        format: { 0: "未知", 1: '男', 2: '女' }
    }, {
        title: '城市',
        dataIndex: 'city',
        width: '10%',
    }, {
        title: '国家',
        dataIndex: 'country',
        width: '10%',
    }, {
        title: '省',
        dataIndex: 'province',
        width: '10%'
    }, {
        title: 'unionid',
        dataIndex: 'unionid',
        width: '10%'
    }, {
        title: '操作',
        dataIndex: 'id',
        width: '10%',
        render: (text, record, index) => (
            <div>
                {global_data.authCode.includes("WECHAT_USER_TEST")?
                <Tooltip title="发送测试消息">
                    <Icon type="wechat" theme="filled" className="table-operate-icon" onClick={this.sendMessage.bind(this, record.id)} />
                </Tooltip>
                :""}
            </div>
        )
    }];

    state = {
        loadData: '',
        queryData: {}
    };

    //发送测试消息
    sendMessage = (id, e) => {
        messager.confirm("是否给该用户发送测试消息？", () => {
            http.post({
                url: '/wx/userInfo/message/test',
                data: { id: id },
                success: (res) => {
                    this.state.loadData(this.state.queryData);
                    messager.notify("发送成功！");
                }
            });
        });
    }

    inputSearch = (value) => {
        let queryData = this.state.queryData;
        queryData.keywords = value
        this.state.loadData(queryData);
        this.setState({ queryData: queryData });
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={8}>
                                <Input.Search
                                    placeholder="用户名/姓名"
                                    onSearch={this.inputSearch}
                                    enterButton
                                />
                            </Col>
                        </Row>
                    )}
                    rowKey="username" url="/wx/userInfo/query/page" columns={this.columns}
                    requestType="get"
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
            </div>
        )
    }
}

export default WechatUserIndex;